export const Footer = {
  paddingY: 5,
  backgroundColor: 'footerBg',
  color: 'onFooterBg',
  a: {
    color: 'onFooterBg',
  },
};

export const Container = {
  display: 'grid',
  gridTemplateColumns: ['1fr', '1fr', '1fr', '1fr 1fr 1fr 1fr'],
  rowGap: '30px',
  columnGap: '30px',
  gridAutoFlow: 'dense',
};

export const Address = {
  marginBottom: 0,
  p: {
    marginBottom: 0,
  },
};

export const Map = {
  gridRow: [null, null, null, 'span 3'],
  gridColumn: [null, null, null, 'span 2 / -1'],
};

export const FooterNavigation = {
  flexDirection: 'column',
  ul: {
    paddingLeft: 0,
    marginBottom: 0,
  },
};

export const FooterNavItem = {
  listStyle: 'none',
  color: 'inherit',
  a: {
    color: 'inherit',
  },
};

export const SocialMediaStyles = {
  SocialMediaWrapper: {},

  SocialMedia: {
    margin: ['1rem 0 0 0', null, '0 auto', null],
  },

  Item: {
    marginRight: '10px',
    ':last-child': {
      marginRight: 0,
    },
    color: 'accent',
  },
};

export const Logo = {
  gridColumnStart: '1',
};
